import {
  LANGUAGE_GROUP_ARABIC,
  LANGUAGE_GROUP_DANISH,
  LANGUAGE_GROUP_ENGLISH,
  LANGUAGE_GROUP_FRENCH,
  LANGUAGE_GROUP_GERMAN,
  LANGUAGE_GROUP_GREENLANDIC,
  LANGUAGE_GROUP_RUSSIAN,
  LANGUAGE_GROUP_SPANISH,
  LANGUAGE_GROUP_SWEDISH,
  LANGUAGE_GROUP_TURKISH,
  LANGUAGE_GROUPS_PRIORITIZED
} from "@/common/language-groups";
import { i18n } from "@/i18n";

import Dictionaries from "./dictionaries";

export const getPrioritizedAvailableFromMethodIds = (methodIds) => {
  const availableLanguageGroups = methodIds.map((methodId) =>
    Dictionaries.getLanguageGroupByMethodId(methodId)
  );

  return [...new Set(availableLanguageGroups)].sort(
    (a, b) => LANGUAGE_GROUPS_PRIORITIZED.indexOf(a) - LANGUAGE_GROUPS_PRIORITIZED.indexOf(b)
  );
};

export const getTranslatedLanguageGroups = () => ({
  [LANGUAGE_GROUP_ARABIC]: i18n.global.t("languageGroups.arabic.translated"),
  [LANGUAGE_GROUP_DANISH]: i18n.global.t("languageGroups.danish.translated"),
  [LANGUAGE_GROUP_ENGLISH]: i18n.global.t("languageGroups.english.translated"),
  [LANGUAGE_GROUP_GERMAN]: i18n.global.t("languageGroups.german.translated"),
  [LANGUAGE_GROUP_GREENLANDIC]: i18n.global.t("languageGroups.greenlandic.translated"),
  [LANGUAGE_GROUP_FRENCH]: i18n.global.t("languageGroups.french.translated"),
  [LANGUAGE_GROUP_SPANISH]: i18n.global.t("languageGroups.spanish.translated"),
  [LANGUAGE_GROUP_TURKISH]: i18n.global.t("languageGroups.turkish.translated"),
  [LANGUAGE_GROUP_RUSSIAN]: i18n.global.t("languageGroups.russian.translated"),
  [LANGUAGE_GROUP_SWEDISH]: i18n.global.t("languageGroups.swedish.translated")
});

export const translateLanguageGroup = (languageGroup) =>
  getTranslatedLanguageGroups()[languageGroup] ?? "";
